import { Button } from '@scuf/common';
import React, { useState } from 'react';
import FeedbackModal from '../../components/FeedbackModal/FeedbackModal';
import { IMAGE_NOT_FOUND } from '../../constants/constants';
import closeIcon from '../../images/close-icon.png';
import './OpportunitiesErrorCard.scss';

const OpportunitiesErrorCard = () => {
    const [showFeedbackModal, setShowFeedbackModal] = useState (false);
    return (
        <div className="opp-error-card">
            {showFeedbackModal && <FeedbackModal open={showFeedbackModal} onClose={() => setShowFeedbackModal(false)} />}
            <div className="no-opp-card__icon">
                <img src={closeIcon} alt={IMAGE_NOT_FOUND}/>
            </div>
            <div className="opp-error-card__title">
            Something went wrong
            </div>
            <div className="opp-error-card__description">
                We couldn’t load the opportunities because of a network error. <br />
                Please try refreshing the browser and try it again. <br />
                If this keeps repeating please reach out to us @ <Button type="link" content="Forge Feedback" onClick={() =>setShowFeedbackModal(true)} />
            </div>
        </div>
        
    );
}; 

export default OpportunitiesErrorCard;